import React from 'react';
import styled from 'styled-components';
import {ChevronUp} from '@styled-icons/boxicons-regular/ChevronUp';
import {ChevronDown} from '@styled-icons/boxicons-regular/ChevronDown';
import {ChevronRight} from '@styled-icons/boxicons-regular/ChevronRight';

import * as AppActions from '../../AppActions';
import Theme from '../../Theme';

function CategoryNode(props) {
  const {node, location, checkSelected} = props;
  const [expand, setExpand] = React.useState(false);

  // const isUrlSelected = React.useCallback(
  //   (url) => {
  //     const [path, query] = (url || '').split('?');
  //     if (path === location.pathname) {
  //       if (!query) {
  //         return true;
  //       } else if (location.search === `?${query}`) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   },
  //   [location.pathname, location.search],
  // );

  // React.useEffect(() => {
  //   for (const it of node.items || []) {
  //     if (isUrlSelected(it.url)) {
  //       setExpand(true);
  //     }
  //   }
  //   return false;
  // }, [isUrlSelected, node]);

  // if (!(node.items?.length > 0)) {
  if (true) {
    const selected = checkSelected(node);
    return (
      <NodeWrapper
        className={'' + (selected ? ' selected' : '')}
        onClick={() => {
          if (node.onClick) {
            node.onClick();
            return;
          }
          if (node.url) {
            AppActions.navigate(node.url);
          }
        }}>
        <div className={'item'}>
          <div className="label">{node.display || node.name}</div>
          <ChevronRight size={18} color={'#fff'} />
        </div>
      </NodeWrapper>
    );
  }

  return (
    <NodeWrapper expand={expand}>
      <div
        className="title"
        onClick={() => {
          setExpand(!expand);
        }}>
        <h3>{node.display || node.name}</h3>
        {expand ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </div>
      <div className="sub-items">
        {node.items.map((it) => {
          const selected = checkSelected(it);
          return (
            <div
              key={it.name}
              style={{
                padding: '10px 0 10px 30px',
                borderTop: '1px solid #ccc',
                cursor: 'pointer',
                color: selected ? Theme.colors.main : 'black',
              }}
              onClick={() => {
                if (it.onClick) {
                  it.onClick();
                  return;
                }
                if (it.url) {
                  AppActions.navigate(it.url);
                }
              }}>
              {it.display / it.name}
            </div>
          );
        })}
      </div>
    </NodeWrapper>
  );
}

const NodeWrapper = styled.li`
  & > .item {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    .label {
      flex: 1;
      font-size: 14px;
      color: white;
    }
  }

  /* & > .sub-items {
    transition: all 200ms;
    opacity: ${(props) => (props.expand ? '1' : '0')};
    max-height: ${(props) => (props.expand ? '10000px' : '0px')};
    pointer-events: ${(props) => (props.expand ? 'auto' : 'none')};
  } */

  &:not(:first-child) {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }
  &.selected,
  :hover {
    background-color: rgba(0, 0, 0, 0.3);

    & > .item > svg {
      fill: yellow;
    }
  }
`;

export default function TdaCategoryTree(props) {
  const {root, title = '', location, checkSelected = () => {}} = props;

  return (
    <Container>
      <h2>{title}</h2>
      <ul className="list">
        {root &&
          root.categories?.length > 0 &&
          root.categories.map((node) => {
            return (
              <CategoryNode
                node={node}
                key={node.name}
                location={location}
                checkSelected={checkSelected}
              />
            );
          })}
      </ul>
    </Container>
  );
}

const Container = styled.div`
  & > h2 {
    padding: 15px 10px;
  }

  & .list {
    border-radius: 8px;
    overflow: hidden;
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: var(--primaryColor);
  }
`;
